module.exports = __webpack_public_path__ + "img/logo1000.e326ddb3.png";